import React from 'react';
import { useStyles } from './styles';
import { FormsTable } from './FormsTable';
import { Filters } from './filter';
import { IRouterProps } from 'pages/orderHistory';
import { TopBar } from './TopBar';
import { Box } from '@material-ui/core';
import { FormsProvider } from './context';

export const Forms = ({ router }: IRouterProps) => {
  const classes = useStyles();

  return (
    <FormsProvider>
      <TopBar />
      <div className={classes.container} id="form-container">
        <Box className={classes.content}>
          <Filters router={router} />
          <FormsTable router={router} />
        </Box>
      </div>
    </FormsProvider>
  );
};
